import moment from "moment";
import CarrelloRiga from "@/models/CarrelloRiga.model.js";
import Carrello from "@/models/Carrello.model.js";
import CartService from '@/services/cart.service.js';
import AddCartResponse from '@/models/AddCartResponse.model.js';

const state = {
    Carrello: null,
    CarrelloTmp: null,
    ShippingAddress: -1,
    SpSpedizione: 0,
    CheckOutAbilitato: false
}

const getters = {
    getPrezzoTotale: (state) => {
        let carrello = getters.getCarrello(state);
        let prezzoTotale = 0;
        if(carrello && carrello.Testata){
            prezzoTotale = carrello.Testata.PrezzoTotale;
        }
        if(state.CarrelloTmp && state.CarrelloTmp.Testata){
            prezzoTotale += state.CarrelloTmp.Testata.PrezzoTotale;
        }
        return prezzoTotale;
    },
    getPrezzoTotaleTmp: (state) => {
        let prezzoTotale = 0;
        if(state.CarrelloTmp && state.CarrelloTmp.Testata){
            prezzoTotale = state.CarrelloTmp.Testata.PrezzoTotale;
        }
        return prezzoTotale;
    },
    getCarrello: (state) => {
        return state.Carrello ?? JSON.parse(localStorage.getItem("carrello"));
    },
    getCarrelloTmp: (state) => {
        return state.CarrelloTmp;
    },
    getNumeroElementi: (state) => {
        let numeroElementi = 0;
        let carrello = getters.getCarrello(state); 

        if(carrello && carrello.Righe){
            carrello.Righe.forEach(riga => {
                numeroElementi += riga.Quantita;
            });
        }
        return numeroElementi;
    },
    getShippingAddress: (state) => {
        return state.ShippingAddress;
    },
    getSpSpedizione: (state) => {
        return state.SpSpedizione;
    },
    getCheckOutAbilitato: (state) =>{
        return state.CheckOutAbilitato;
    }
}

const mutations = {
    setShippingAddress: (state, codiceDestinazione) => {
        state.ShippingAddress = codiceDestinazione
    },
    updateCarrello: (state, carrello) => {
        state.Carrello = carrello;
        localStorage.setItem('carrello', JSON.stringify(state.Carrello));
    },
    resetCarrelloTmp: (state) => {
        state.CarrelloTmp = null;
    },
    updateRow: (state, data) => {
        let currentCarrello = state.CarrelloTmp;
        if(!currentCarrello){
            currentCarrello = new Carrello();
            currentCarrello.Testata.DataCreazione = moment().format("YYYY-MM-DD HH:mm:ss");
            currentCarrello.Testata.Valuta = data.Valuta;
        }
        currentCarrello.Testata.DataModifica = moment().format("YYYY-MM-DD HH:mm:ss");
        let index = currentCarrello.Righe.findIndex(value => {
            return value.CodiceArticolo === data.CodiceArticolo;
        });
        let  articolo = new CarrelloRiga();
        if(index < 0){
            index = currentCarrello.Righe.length
            articolo.Quantita = 0;
        }
        else{
            Object.assign(articolo, currentCarrello.Righe[index]);
        }
        articolo.setDati(
            data.CodiceArticolo,
            data.Quantita,
            data.PrezzoNetto,
            data.PrezzoListino,
            data.Sconto1,
            data.Sconto2,
            data.Sconto3,
            data.Sconto4,
            data.Sconto5,
            data.ValoreSconto1,
            data.ValoreSconto2,
            data.ValoreSconto3,
            data.ValoreSconto4,
            data.ValoreSconto5,
            (data.PrezzoNetto * data.Quantita),
            data.Catalogo,
            data.DescrizioneArticolo,
            data.DescrizioneTaglia,
            data.DescrizioneColore,
            data.UrlImmagine,
            data.PrezzoAgente,
            (data?.IsBackorder ?? 0),
            data?.VenditaSoloMultipli,
            data?.Multipli
            );
        if(articolo.Quantita == 0){
            currentCarrello.Righe.splice(index, 1);
        }
        else{
            currentCarrello.Righe[index] = articolo;
        }
        currentCarrello.Testata.PrezzoTotale = 0;
        currentCarrello.Righe.forEach(element => {
            currentCarrello.Testata.PrezzoTotale += element.PrezzoTotale;
        });
        state.CarrelloTmp = currentCarrello;
    },
    removeCart: (state) => {
        state.Carrello = null;
        localStorage.removeItem("carrello");
    },
    setSpSpedizione: (state, data) => {
        state.SpSpedizione = data;
    },
    setCheckOutAbilitato: (state, data) =>{
        state.CheckOutAbilitato = data;
    }
}

const actions = {
    setCarrello: ({commit}, requestData) => {
        return CartService.setCart(requestData.token, getters.getCarrelloTmp(state),requestData.isBackorder).then(
            (data) => {
                if(data){
                    let response = new AddCartResponse();
                    Object.assign(response, data);
                    if(response.Status == 1){
                        return true;
                    }
                    else{
                        return false;
                    }
                }
            }
        )
        .catch(
            error => {return false}
        )
    },

    updateCartRow: ({commit}, requestData) => {
        return CartService.updateRow(requestData.token, requestData.idCarrello, requestData.codiceArticolo, requestData.quantita, requestData.isBackorder).then(
            (data) => {
                if(data){
                    let response = new AddCartResponse();
                    Object.assign(response, data);
                    
                    if(response.Status == 1){
                        return true;
                    }
                    else{
                        return false;
                    }
                }
            }
        )
        .catch(
            error => {return false}
        );
    },

    deleteCartRow:  ({commit}, requestData) => {   
        return CartService.deleteRow(requestData.token, requestData.idCarrello, requestData.codiceArticolo, requestData.isBackorder, requestData.username).then(
            
            (data) => {
                if(data){
                    let response = new AddCartResponse();
                    Object.assign(response, data);
                    
                    if(response.Status == 1){
                        return true;
                    }
                    else{
                        return false;
                    }
                }
            }
        )
        .catch(
            error => {return false}
        );
    }
}

export default{
    namespeced: true,
    state,
    getters,
    mutations,
    actions
}